interface ILocalStorageConfig {
  userKey: string;
  tokenKey: string;
}

export default {
  userKey: '@SPIRY:USER',
  tokenKey: '@SPIRY:TOKEN',
} as ILocalStorageConfig;
